import { combineReducers } from 'redux';
import * as appTypes from '../app/appTypes';
import { isLoadingDataState } from '../../utils';
import createReducer from '../../reducerHelper';
import * as types from './types';
import * as patientTypes from '../patient/types';

const autocompleteForceRefreshReducer = createReducer(false)({
  [patientTypes.UPDATE_PATIENT_TRIGGER]: () => true,
  [types.AUTOCOMPLETE_FORCE_REFRESH]: (state, action) =>
    action.payload || false,
});

const initializeAutocompleteResult = {
  isFetching: false,
  fetchCompleted: false,
  participants: [],
  orderingProvider: [],
  billingCode: [],
};

/*
  Shape: {
    participants: [],
    members: [],
    billingCodes: []
  }
 */
const autocompleteReducer = (state = initializeAutocompleteResult, action) => {
  const { payload } = action;
  const sortFunc = (a, b) => {
    return a.lastName
      .toLowerCase()
      .localeCompare(b.lastName.toLowerCase(), 'en', { sensitivity: 'base' });
  };

  switch (action.type) {
    case appTypes.CLEAR_STATE:
      return initializeAutocompleteResult;

    case `${types.GET_AUTOCOMPLETE}_PENDING`:
      return isLoadingDataState();

    case `${types.GET_AUTOCOMPLETE}_REJECTED`:
      // silently fail in order to not impact the user's experience.
      return {
        ...initializeAutocompleteResult,
        fetchCompleted: true,
        hasError: true,
      };

    case `${types.GET_AUTOCOMPLETE}_FULFILLED`:
      return {
        fetchCompleted: true,
        orderingProvider: payload.members.sort(sortFunc),
        billingCodes: payload.billingCodes,
        participants: payload.participants,
      };

    default:
      return state;
  }
};

export const AUTOCOMPLETE_REDUCERS = {
  AUTOCOMPLETE_RESULTS: 'searchAutocomplete',
  AUTOCOMPLETE_FORCE_REFRESH: 'autocompleteForceRefresh',
};

export default combineReducers({
  [AUTOCOMPLETE_REDUCERS.AUTOCOMPLETE_RESULTS]: autocompleteReducer,
  [AUTOCOMPLETE_REDUCERS.AUTOCOMPLETE_FORCE_REFRESH]: autocompleteForceRefreshReducer,
});



// WEBPACK FOOTER //
// ./src/state/reducers/autocomplete/autocompleteReducers.js